import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectInvite} from 'api/invite';
import {loadInterestInvite as load, submitInterestInvite as submit} from 'flows/interest/invite/index';
import Spinner from 'components/Spinner';

import InterestInvite from './component';

export class InterestInviteContainer extends React.Component {
  constructor() {
    super();
    this.login = this.login.bind(this);
  }
  componentDidMount() {
    this.props.load({id: this.props.params.inviteId});
  }
  login() {
    this.props.submit({id: this.props.params.inviteId});
  }
  render() {
    const {data, loaded} = this.props.invite || {};

    if (loaded) {
      return (
        <InterestInvite login={this.login} invite={data} />
      );
    }
    return (
      <Spinner />
    );
  }
}

InterestInviteContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  invite: PropTypes.object,
  params: PropTypes.object.isRequired,
};

export const mapStore = (store, ownProps) => ({
  invite: selectInvite(store, ownProps.params.inviteId)
});

export default connect(mapStore, {load, submit})(InterestInviteContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/invite/index.js